<template>
	<div class="bg-color-gray-95 pt-300 pb-150 position-relative">
		<div class="container">
			<div class="px-400-md">
				<p class="label-sm text-transform-uppercase text-color-gray-20 text-align-center"
					>Trusted by 2 million+ people</p
				>
				<HorizontalScroll v-if="appStore.isMobile" class="display-flex justify-content-space-between mt-150">
					<template #scroll-items>
						<div class="display-flex gap-300">
							<div
								v-for="rating in ratingsDetails"
								:key="rating.svgName"
								class="display-flex flex-direction-column align-items-center justify-content-flex-end"
							>
								<div class="text-color-white text-align-center">
									<BaseSvgIcon :name="rating.svgName" :height="rating.height" :width="rating.width" />
								</div>
								<RatingsStars class="mt-100" :rating="rating.rating" stars-color="#C5973D" size="18" />
							</div>
						</div>
					</template>
				</HorizontalScroll>
				<div v-else class="display-flex justify-content-space-between align-items-flex-end mt-150">
					<div
						v-for="rating in ratingsDetails"
						:key="rating.svgName"
						class="display-flex flex-direction-column align-items-center"
					>
						<div class="text-color-white text-align-center">
							<BaseSvgIcon :name="rating.svgName" :height="rating.height" :width="rating.width" />
						</div>
						<RatingsStars class="mt-100" :rating="rating.rating" stars-color="#C5973D" size="16" />
					</div>
				</div>

				<p class="text-color-gray-30 text-align-center body-xs mt-200"
					><BaseButton
						classes="link text-color-current-color text-decoration-underline"
						@click="scrollToAnchor('socialStatsDisclaimers')"
						>Learn more</BaseButton
					>
					about rating details.</p
				>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import HorizontalScroll from '@components/wizard/horizontal-scroll.vue';
import RatingsStars from '@components/marketing-site/ratings-stars.vue';
import { scrollToAnchor } from '@utils/scroll-to';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const ratingsDetails: Array<{
	svgName: string;
	height: number;
	width: number;
	rating: string;
}> = [
	{
		svgName: 'logo-nerdwallet',
		height: 24,
		width: 132,
		rating: '5'
	},
	{
		svgName: 'logo-business-insider',
		height: 25.597,
		width: 73,
		rating: '4.1'
	},
	{
		svgName: 'logo-investopedia',
		height: 19,
		width: 120.854,
		rating: '4.7'
	},
	{ svgName: 'logo-apple', height: 32, width: 26.791, rating: '4.8' },
	{ svgName: 'logo-google', height: 27, width: 81, rating: '4.7' }
];
</script>

<style lang="scss" scoped>
@use '../../styles/constants/colors' as *;
@use 'sass:map';

.bg-color-gray-95 {
	background-color: map.get($grays, 95);
}
</style>
